<template>
  <div class="topDiv mainContent" style>
    <el-row class="searchDiv">
      <el-col :span="24" class="sreachInputMargin">
        <el-input
          placeholder="请输入内容"
          v-model="form.sreachWord"
          class="input-with-select"
        >
          <!-- <el-select
            v-model="form.city"
            slot="prepend"
            placeholder="地区"
            style="color: #000;background: white;height:48px"
            @change="getUserDisabledInfoList"
          >
            <el-option
              v-for="(item, index) in allCity_arr"
              :label="item.label"
              :value="item.label"
              :key="index"
            ></el-option>
          </el-select> -->
        </el-input>
      </el-col>
      <el-col
        :span="2"
        @click.native="getUserDisabledInfoList"
        class="sreachButton"
        >搜索</el-col
      >
    </el-row>
    <div class="mainContent" style="height: 100%">
      <el-row>
        <el-col :span="6" class="criteriaDesc"><span >学历要求</span></el-col>
        <el-col :span="6" class="criteriaDesc"><span>期望薪资</span></el-col>
        <el-col :span="6" class="criteriaDesc"><span>工作年限</span></el-col>
        <el-col :span="6" class="criteriaDesc"><span>年龄要求</span></el-col>
      </el-row>

      <el-row style="margin: 13px 0 0 24px">
        <el-col :span="2">
          <el-select
            v-model="form.educationStart"
            style="width: 90px; border-radius: 6px"
            size="small"
            @change="getUserDisabledInfoList"
          >
            <el-option
              v-for="(item, index) in education_arr"
              :key="index + '_start'"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="padding-left: 16px">
          <el-select
            v-model="form.educationEnd"
            style="width: 90px; border-radius: 6px"
            size="small"
            @change="getUserDisabledInfoList"
          >
            <el-option
              v-for="(item, index) in education_arr"
              :key="index + '_end'"
              :label="item.text"
              :value="item.value"
              v-if="
                form.educationStart == 'all' ||
                (form.educationStart < item.value && item.value != 'all')
              "
            ></el-option>
          </el-select>
        </el-col>

        <!-- 期望薪资 -->
        <el-col :span="2" style="margin-left: 6px">
          <el-select
            v-model="form.salaryStart"
            @change="getUserDisabledInfoList"
            style="width: 90px; border-radius: 6px"
            size="small"
          >
            <el-option
              v-for="(item, index) in selectSalary"
              :key="index + '_start'"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="padding-left: 16px">
          <el-select
            v-model="form.salaryEnd"
            @change="getUserDisabledInfoList"
            style="width: 90px; border-radius: 6px"
            size="small"
          >
            <el-option
              v-for="(item, index) in selectSalary"
              :key="index + '_start'"
              :label="item.text"
              :value="item.value"
              v-if="
                form.salaryStart == 'all' ||
                (form.salaryStart < item.value && item.value != 'all')
              "
            ></el-option>
          </el-select>
        </el-col>

        <!-- 工作年限 -->
        <el-col :span="2" style="margin-left: 6px">
          <el-select
            v-model="form.workYearStart"
            @change="getUserDisabledInfoList"
            style="width: 90px; border-radius: 6px"
            size="small"
          >
            <el-option
              v-for="(item, index) in workYears"
              :key="index + '_start'"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="padding-left: 16px">
          <el-select
            v-model="form.workYearEnd"
            @change="getUserDisabledInfoList"
            style="width: 90px; border-radius: 6px"
            size="small"
          >
            <el-option
              v-for="(item, index) in workYears"
              :key="index + '_start'"
              :label="item.text"
              :value="item.value"
              v-if="
                form.workYearStart == 'all' ||
                (form.workYearStart < item.value && item.value != 'all')
              "
            ></el-option>
          </el-select>
        </el-col>

        <!-- 年龄要求 -->
        <el-col :span="2" style="margin-left: 6px">
          <el-select
            v-model="form.age"
            @change="getUserDisabledInfoList"
            style="width: 90px; border-radius: 6px"
            size="small"
          >
            <el-option
              v-for="item in selectAges"
              :key="item.value"
              :value="item.text"
              >{{ item.text }}</el-option
            >
          </el-select>
        </el-col>
      </el-row>

      <!-- <el-row style="margin-top: 10px">
        <el-col :span="1" style="width: 60px" class="areaStyle"
          >受损部位</el-col
        >
        <el-col :span="20" class="areaStyle">
          <el-checkbox-group
            v-model="damagedArea"
            @change="getUserDisabledInfoList"
          >
            <el-checkbox
              v-for="item in areas"
              :label="item.text"
              :key="item.value"
              >{{ item.text }}</el-checkbox
            >
          </el-checkbox-group>
        </el-col>
      </el-row> -->

      <el-row style="margin-top: 10px; margin-left: -15px">
        <!-- <el-col :span="3" class="areaStyle">
          <el-select
            ref="salary"
            class="search-input1 null-input input"
            placeholder="受损等级"
            v-model="form.damagedLevel"
            @change="getUserDisabledInfoList"
          >
            <el-option
              v-for="(item, index) in damagedLevel_arr"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col> -->

        <el-col :span="3" style="margin-left:22px;" class="areaStyle">
          <el-select
            ref="salary"
            class="search-input1 null-input input"
            placeholder="当前求职状态"
            v-model="form.curJobStatus"
            @change="getUserDisabledInfoList"
          >
            <el-option
              v-for="(item, index) in curJobStatus_arr"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="areaStyle">
          <el-select
            ref="salary"
            class="search-input1 null-input input"
            placeholder="城市"
            v-model="form.city"
            @change="getUserDisabledInfoList"
          >
            <el-option
              v-for="(item, index) in allCity_arr"
              :key="index"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { initDictOptions, filterDictText } from "@/comm/JDictSelectUtil";
import { getAction, postAction, putAction } from "@/comm/manage";
export default {
  name: "",
  components: {},
  data() {
    return {
      menuIndex: 3,
      areas: [],
      sreachValue: null,
      input3: "",
      select: null,
      damagedArea: [],
      damagedLevel_arr: [],
      curJobStatus_arr: [],
      allCity_arr: [],
      form: {
        educationStart: null, //学历
        educationEnd: null,
        salaryStart: null,
        salaryEnd: null,
        workYearStart: null,
        workYearEnd: null,
        age: null,
        curJobStatus: null,
        damagedLevel: null,
        city: null,
        sreachWord: null,
        pageNo:0,
        pageSize:1000
      },
      selectDegree: [],
      education_arr: [],
      selectAges: [],

      workYears: [],

      selectSalary: [],
      selectPostion: [
        { label: "全部职位", value: "all" },
        { label: "运营", value: "在职-考虑机会" },
        { label: "当前已发布的所有职位归属", value: "在职-月内到岗" },
      ],
    };
  },
  props: ["searchparams"],
 watch: {
     '$route'(to,from){
        if(to.params.searchWord){
          this.searchparams = to.params.searchWord;
         
          if (this.searchparams.type == "position") {
            this.form.sreachWord = this.searchparams.positionName;
          } else if (this.searchparams.type == "cityorpositon") {
            this.form.sreachWord = this.searchparams.positionName;
            this.form.city = this.searchparams.city;
          } else {
          }
                    
        }
         
   },

  },
  created() {
    this.initDictConfig();

    if (
      this.$store.state.sys_dicts.allCity &&
      this.$store.state.sys_dicts.allCity.length > 0
    ) {
      this.allCity_arr = this.$store.state.sys_dicts.allCity;
    } else {
      this.getAllCity();
    }
    if(this.searchparams){
        if (this.searchparams.type == "position") {
          this.form.sreachWord = this.searchparams.positionName;
        } else if (this.searchparams.type == "cityorpositon") {
          this.form.sreachWord = this.searchparams.positionName;
          this.form.city = this.searchparams.city;
        } else {
        }
    }
   
    this.getUserDisabledInfoList();
  },
  methods: {
    
    getAllCity() {
      var params = {
        pageSize: 1000,
        deep: 1,
      };
      getAction("/chinadata/tsChinaDataLeave/list", params).then((res) => {
        if (res.success) {
          const nodes = res.result.records.map((item) => ({
            value: item.cid,
            label: item.name,
            leaf: item.cid.length > 6,
          }));
          this.allCity_arr = nodes.sort(this.compare("value"));
          this.$store.dispatch("setAllCity", this.allCity_arr);
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
      });
    },
    compare(key) {
      return function (obj1, obj2) {
        if (Number(obj1[key]) < Number(obj2[key])) {
          return -1;
        } else if (obj1[key] === obj2[key]) {
          return 0;
        } else {
          return 1;
        }
      };
    },

    getUserDisabledInfoList() {
      // if (!this.form.educationStart || this.form.educationStart == "all") {
      //   this.form.educationStart = null;
      // }

      // if (!this.form.educationEnd || this.form.educationEnd == "all") {
      //   this.form.educationEnd = null;
      // }

      // if (!this.form.salaryStart || this.form.salaryStart == "all") {
      //   this.form.salaryStart = null;
      // }

      // if (!this.form.salaryEnd || this.form.salaryEnd == "all") {
      //   this.form.salaryEnd = null;
      // }

      // if (!this.form.workYearStart || this.form.workYearStart == "all") {
      //   this.form.workYearStart = null;
      // } else

      // if (this.form.workYearStart == 12 || this.form.workYearStart == 13) {
      //   this.form.udJobIdentity = 1;
      // }

      // if (!this.form.workYearEnd || this.form.workYearEnd == "all") {
      //   this.form.workYearEnd = null;
      // }
      if (this.form.workYearStart == "0" || this.form.workYearEnd == "0") {
        this.form.udJobIdentity = "2";
      }

      if (this.damagedArea) {
        this.form.damagedArea = this.damagedArea.toString();
      } else {
        this.form.damagedArea = null;
      }
      // if(this.damagedArea && this.damagedArea != "all") {
      //   this.form.damagedAreaString = this.damagedArea.toString();
      // }

      // if (!this.form.curJobStatus || this.form.curJobStatus == "all") {
      //   this.form.curJobStatus = null;
      // }

      // if (!this.form.damagedLevel || this.form.damagedLevel == "all") {
      //   this.form.damagedLevel = null;
      // }

      // if (!this.form.city || this.form.city == "all") {
      //   this.form.city = null;
      // }

      if (!this.form.sreachWord) {
        this.form.sreachWord = null;
      }

      if (this.form.age && this.form.age != "不限") {
        if (this.form.age.indexOf("以上") != -1) {
          this.form.ageStart = this.form.age.substring(
            0,
            this.form.age.indexOf("以上")
          );
          this.form.ageEnd = "100";
        } else {
          let ages = this.form.age.split("-");
          this.form.ageStart = ages[0];
          this.form.ageEnd = ages[1];
        }
      }

      getAction("/rainbow/tsUserDisabled/getUserDisabledInfo", this.form).then(
        (res) => {
          if (res.success) {
            this.$store.dispatch("setSearchPeopleList", res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message);
          }
        }
      );
    },

    initDictConfig() {
      initDictOptions("damagedArea").then((res) => {
        if (res.success) {
          this.areas = res.result;
        }
      });
      initDictOptions("workYears").then((res) => {
        if (res.success) {
          this.workYears = res.result;
        }
      });
      initDictOptions("damagedLevel").then((res) => {
        if (res.success) {
          this.damagedLevel_arr = res.result;
        }
      });
      initDictOptions("selectEducation").then((res) => {
        if (res.success) {
          this.education_arr = res.result;
        }
      });
      initDictOptions("selectSalary").then((res) => {
        if (res.success) {
          this.selectSalary = res.result;
        }
      });

      initDictOptions("cur_job_status").then((res) => {
        if (res.success) {
          this.curJobStatus_arr = res.result;
        }
      });
      initDictOptions("selectAges").then((res) => {
        if (res.success) {
          this.selectAges = res.result;
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>

.topDiv {
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 100%;
  background-color: #F0F2F5;
  margin: 0 auto;

  .searchDiv {
    margin-bottom: 30px;

    .sreachInputMargin {
      width: 600px;
    }

    >>>.el-input-group__append, >>>.el-input-group__prepend {
      background-color: #F5F7FA;
      color: #000;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 20px;
      width: 100px;
      white-space: nowrap;

      input::-webkit-input-placeholder {
        color: #000;
      }

      input::-moz-input-placeholder {
        color: #000;
      }

      input::-ms-input-placeholder {
        color: #000;
      }
    }

    >>>.el-input__inner {
      -webkit-appearance: none;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #fff;
      box-sizing: border-box;
      color: #000;
      display: inline-block;
      font-size: inherit;
      height: 50px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
      margin-top:10px;
    }

    // >>>.input-with-select {
    //   border: none;
    //   border-radius: 0px;
    //   outline: none;
    // }
    >>>.input-with-select {
      border: 0px solid #f82b18;


      &:hover {
        // border: 1px solid #f82b18;
      }

      border-radius: 6px;
      outline: none;
      font-size: 16px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      line-height: 24px;
    }

    .sreachButton {
      width: 140px;
      height: 50px;
      background: #f82b18;
      line-height: 50px;
      text-align: center;
      margin-top: 10px;
      color: #fff;
      cursor: pointer;
      margin-left:0px;
    }
  }

  >>>.el-input--suffix input::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.65);
    /* placeholder字体大小 */
    font-size: 14px;
  }

  .search-input input.el-input__inner {
    border: 0px solid #f82b18;
  }

  .search-input1 input.el-input__inner {
    border: 0px solid #f82b18;
    height: 20px;
    background-color: white;
    color: black;
  }

  .null-input >>> .el-input__inner {
    // background-color: #F0F2F5;
    color: #606266;
    height: 44px;
    border-radius: 0;
    border-width: 0px;
    font-size: 14px;
    line-height: 44px;
  }

  .input ::-webkit-input-placeholder {
    color: black;
    font-family: 'SourceHanSansCN';
    font-size: 13px;
  }

  .input ::-moz-placeholder {
    color: black;
    font-family: 'SourceHanSansCN';
    font-size: 13px;
  }

  .input ::-ms-input-placeholder {
    color: black;
    font-family: 'SourceHanSansCN';
    font-size: 13px;
  }

  .criteriaDesc {
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    padding: 20px 0 0 24px;
  }

  >>>.el-checkbox__input {
    display: none;
  }

  .areaStyle {
    line-height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    margin-left: 32px;
    text-align: left;
    margin-top: -10px;
  }

  .mainContent {
    padding: 0px 0px 0px 0px;
    position: relative;
    font-size: 18px;
    height: 100%;
    text-align: left;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
  }
}
</style>